import {CommonModule} from '@angular/common';
import {ComplaintPageComponent} from './complaint-page.component';
import {ComplaintPageRoutingModule} from './complaint-page-routing.module';
import {MaterialModule} from '../shared/material.module';
import {NgModule} from '@angular/core';
import {TitleModule} from '../layout/components/title/title.module';

@NgModule({
  declarations: [ComplaintPageComponent],
  imports: [
    CommonModule,
    ComplaintPageRoutingModule,
    MaterialModule,
    TitleModule
  ]
})

export class ComplaintPageModule {
}
